import { useTranslation } from "react-i18next";
import { FundManagerInfoArtifactType } from "types/AssistantTypes";
import { formatItalianNumber } from "utils/formatUtils";
import gestore from "../fineco-product-card/components/informazioniGestore.module.scss";
import chat from "../../../chat/chat.module.scss";
import styles from "./finecoFundManagerInfoArtifact.module.css";

type Props = {
  data: FundManagerInfoArtifactType;
};

/**
 * «Informazioni dal Gestore» of one FAM fund of funds, returned by the
 * `get_fund_manager_info` tool. Rendered from the data so the note and the
 * holdings appear verbatim — the agent must not re-type them (it paraphrases,
 * Fineco feedback 2026-09-08). Bare on purpose: no frame, no titles, no date —
 * the agent's one-line message already names the fund and the date
 * (Robert, 2026-09-08). The note reuses the chat message typography so it is
 * indistinguishable from the agent's text. Only the requested section(s) are rendered.
 */
const FinecoFundManagerInfoArtifact = ({ data }: Props) => {
  const { t } = useTranslation();
  const sections = data.sections ?? "entrambi";
  const showComposizione = sections !== "nota" && (data.composizione?.length ?? 0) > 0;
  const showNota = sections !== "composizione" && !!data.nota;
  return (
    <div className={styles.root}>
      {showComposizione && (
        <table className={gestore.table}>
          <thead>
            <tr>
              <th className={gestore.th}>{t("productCard.strumento")}</th>
              <th className={gestore.th}>{t("productCard.isin")}</th>
              <th className={gestore.th}>{t("productCard.categoria")}</th>
              <th className={`${gestore.th} ${gestore.right}`}>{t("productCard.peso")}</th>
            </tr>
          </thead>
          <tbody>
            {data.composizione.map((h) => (
              <tr key={`${h.isin}-${h.strumento}`} className={gestore.tr}>
                <td className={gestore.td}>{h.strumento}</td>
                <td className={gestore.td}>{h.isin}</td>
                <td className={gestore.td}>{h.categoria}</td>
                <td className={`${gestore.td} ${gestore.right}`}>{formatItalianNumber(h.peso, 2)}%</td>
              </tr>
            ))}
          </tbody>
        </table>
      )}
      {showNota && (
        <div className={chat.reactMarkdown}>
          <p className={`${chat.chatPCopy} ${styles.note}`}>{data.nota}</p>
        </div>
      )}
    </div>
  );
};

export default FinecoFundManagerInfoArtifact;
